export default __webpack_public_path__ + "static/media/CarImages.KigerSmall.fb63cf00.jpg";